"use client";

import FurnitureOptionalDimensionsFields, {
  SpecOptionPills,
} from "@/components/listing/FurnitureOptionalDimensionsFields";
import {
  CHAIR_MATERIALS,
  formatChairMaterialLabel,
  type ChairMaterial,
} from "@/lib/listing/chairListingSpec";
import {
  DINING_TABLE_TOP_MATERIALS,
  formatDiningTableTopMaterialLabel,
  type DiningTableTopMaterial,
} from "@/lib/listing/diningTableChairListingSpec";
import {
  TABLE_CHAIR_COUNTS,
  type FurnitureTableBundleSpecFormState,
  type TableChairCount,
} from "@/lib/listing/furnitureTableBundleListingSpec";
import { cn } from "@/lib/utils";

interface TableChairBundleSpecFieldsProps {
  value: FurnitureTableBundleSpecFormState;
  onChange: (next: FurnitureTableBundleSpecFormState) => void;
  className?: string;
}

export default function TableChairBundleSpecFields({
  value,
  onChange,
  className = "",
}: TableChairBundleSpecFieldsProps) {
  return (
    <div className={cn("space-y-6", className)}>
      <div className="space-y-2">
        <p className="text-sm font-medium text-foreground">
          How many chairs? <span className="text-red-500">*</span>
        </p>
        <SpecOptionPills
          options={TABLE_CHAIR_COUNTS}
          selected={value.chairCount}
          onSelect={(count: TableChairCount) =>
            onChange({ ...value, chairCount: count })
          }
          formatLabel={(count) => `${count}`}
        />
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium text-foreground">
          Table top material <span className="text-red-500">*</span>
        </p>
        <SpecOptionPills
          options={DINING_TABLE_TOP_MATERIALS}
          selected={value.tableTopMaterial}
          onSelect={(material: DiningTableTopMaterial) =>
            onChange({ ...value, tableTopMaterial: material })
          }
          formatLabel={formatDiningTableTopMaterialLabel}
        />
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium text-foreground">
          Chair material <span className="text-red-500">*</span>
        </p>
        <SpecOptionPills
          options={CHAIR_MATERIALS}
          selected={value.chairMaterial}
          onSelect={(material: ChairMaterial) =>
            onChange({ ...value, chairMaterial: material })
          }
          formatLabel={formatChairMaterialLabel}
        />
      </div>

      <FurnitureOptionalDimensionsFields
        summaryLabel="Table size (optional)"
        axes={{ length: true, width: true, height: false }}
        value={{
          lengthFt: value.lengthFt,
          widthFt: value.widthFt,
          heightFt: value.heightFt,
        }}
        onChange={(dims) =>
          onChange({
            ...value,
            lengthFt: dims.lengthFt,
            widthFt: dims.widthFt,
            heightFt: dims.heightFt,
          })
        }
      />
    </div>
  );
}
